import store from "@/store";
const directorAuth = (to, from, next) => {
  let access_token = localStorage.getItem("access_token");

  if (from.path === "/passwordSetting") {
    next();
    return;
  }
  if (!store.getters.isDirectorAuthenticated || !access_token) {
    // 아직 로그인이 안 되있는 유저니까 막아야 한다.
    alert("로그인이 필요합니다");
    next("/director/loginDo");
  } else {
    next();
  }
};
const funeralAuth = (to, from, next) => {
  let access_token = localStorage.getItem("access_token");

  if (from.path === "/passwordSetting") {
    next();
    return;
  }
  if (!store.getters.isFuneralAuthenticated || !access_token) {
    // 아직 로그인이 안 되있는 유저니까 막아야 한다.
    alert("로그인이 필요합니다");

    next("/funeral/loginDo");
  } else {
    next();
  }
};
const corpAuth = (to, from, next) => {
  let access_token = localStorage.getItem("access_token");
  if (from.path === "/passwordSetting") {
    next();
    return;
  }
  if (!store.getters.isCorpAuthenticated || !access_token) {
    // 아직 로그인이 안 되있는 유저니까 막아야 한다.
    alert("로그인이 필요합니다");
    next("/corp/loginDo");
  } else {
    next();
  }
};

export default [
  {
    meta: {
      title: "Landing"
    },
    path: "/",
    name: "",
    // beforeEnter: onlyAuth,
    component: () => import("@/views/Main.vue")
  },
  {
    meta: {
      title: "LandingFaq"
    },
    path: "/sub/faq",
    name: "",
    // beforeEnter: onlyAuth,
    component: () => import("@/views/sub/faq.vue")
  },
  {
    meta: {
      title: "LandingKeepsake"
    },
    path: "/sub/keepsake",
    name: "",
    // beforeEnter: onlyAuth,
    component: () => import("@/views/sub/keepsake.vue")
  },
  {
    meta: {
      title: "LandingNotice"
    },
    path: "/sub/notice",
    name: "",
    // beforeEnter: onlyAuth,
    component: () => import("@/views/sub/notice.vue")
  },
  {
    meta: {
      title: "LandingNoticeView"
    },
    path: "/sub/noticeView",
    name: "",
    // beforeEnter: onlyAuth,
    component: () => import("@/views/sub/noticeView.vue")
  },
  
  // 비밀번호 재설정

  // 상조
  {
    meta: {
      title: "Main"
    },
    path: "/corp/main",
    name: "CorpMain",
    beforeEnter: corpAuth,
    component: () => import("@/views/corp/Main.vue")
  },
  {
    meta: {
      title: "MyPage"
    },
    path: "/corp/mypage",
    name: "CorpMyPage",
    beforeEnter: corpAuth,
    component: () => import("@/views/corp/MyPage.vue")
  },
  {
    meta: {
      title: "DirectorList"
    },
    path: "/corp/director-list",
    name: "CorpDirectorList",
    beforeEnter: corpAuth,
    component: () => import("@/views/corp/DirectorList.vue")
  },
  {
    meta: {
      title: "ObituaryList"
    },
    path: "/corp/obituary-list",
    name: "CorpObituaryList",
    beforeEnter: corpAuth,
    component: () => import("@/views/corp/ObituaryList.vue")
  },
  {
    meta: {
      title: "ObituaryMessageList"
    },
    path: "/corp/obituary-message",
    name: "CorpObituaryMessageList",
    beforeEnter: corpAuth,
    component: () => import("@/views/corp/ObituaryMessageList.vue")
  },
  // {
  //   meta: {
  //     title: "Obituary"
  //   },
  //   path: "/corp/obituary",
  //   name: "CorpObituary",
  //   beforeEnter: corpAuth,
  //   component: () => import("@/views/funeral/Obituary.vue")
  // },
  // 장례지도사
  {
    meta: {
      title: "Main"
    },
    path: "/director/main",
    name: "DirectorMain",
    beforeEnter: directorAuth,
    component: () => import("@/views/director/Main.vue")
  },
  {
    meta: {
      title: "MyPage"
    },
    path: "/director/mypage",
    name: "DirectorMyPage",
    beforeEnter: directorAuth,
    component: () => import("@/views/director/MyPage.vue")
  },
  {
    meta: {
      title: "ObituaryList"
    },
    path: "/director/obituary-list",
    name: "DirectorObituaryList",
    beforeEnter: directorAuth,
    component: () => import("@/views/director/ObituaryList.vue")
  },
  {
    meta: {
      title: "ObituaryMessageList"
    },
    path: "/director/obituary-message",
    name: "DirectorObituaryMessageList",
    beforeEnter: directorAuth,
    component: () => import("@/views/director/ObituaryMessageList.vue")
  },

  // 장례식장
  {
    meta: {
      title: "Main"
    },
    path: "/funeral/main",
    name: "FuneralMain",
    beforeEnter: funeralAuth,
    component: () => import("@/views/funeral/Main.vue")
  },
  {
    meta: {
      title: "MyPage"
    },
    path: "/funeral/mypage",
    name: "FuneralMyPage",
    beforeEnter: funeralAuth,
    component: () => import("@/views/funeral/MyPage.vue")
  },
  {
    meta: {
      title: "ObituaryList"
    },
    path: "/funeral/obituary-list",
    name: "FuneralObituaryList",
    beforeEnter: funeralAuth,
    component: () => import("@/views/funeral/ObituaryList.vue")
  },
  {
    meta: {
      title: "ObituaryMessageList"
    },
    path: "/funeral/obituary-message",
    name: "FuneralObituaryMessageList",
    beforeEnter: funeralAuth,
    component: () => import("@/views/funeral/ObituaryMessageList.vue")
  }
];
